import { useCallback, useRef, useState } from 'react';

const useSubmitLock = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const lockRef = useRef(false);

  const runWithSubmitLock = useCallback(async (callback) => {
    if (lockRef.current) return;

    lockRef.current = true;
    setIsSubmitting(true);
    try {
      await callback();
    } finally {
      lockRef.current = false;
      setIsSubmitting(false);
    }
  }, []);

  return {
    isSubmitting,
    runWithSubmitLock,
  };
};

export default useSubmitLock;
